import { Chart } from '@frontend/chart/types';

export const CONSUMPTION_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Safety gloves', data: [{ label: 'full_period', value: 48 }] },
        { name: 'Ear protection', data: [{ label: 'full_period', value: 36 }] },
        { name: 'Safety glasses', data: [{ label: 'full_period', value: 28 }] },
        { name: 'Work boots', data: [{ label: 'full_period', value: 19 }] },
        { name: 'Hi-vis vest', data: [{ label: 'full_period', value: 14 }] },
        { name: 'Hard hat', data: [{ label: 'full_period', value: 9 }] },
        { name: 'Dust mask', data: [{ label: 'full_period', value: 5 }] },
        { name: 'Knee pads', data: [{ label: 'full_period', value: 2 }] }
    ]
};
